/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { TimeClockRegisterViewService } from '../../view/time-clock-register.view-service';
import { ContainerModel } from '@typescript-kit/view';

@Component({
  selector: 'app-time-clock-register',
  templateUrl: './time-clock-register.component.html',
  styleUrls: ['./time-clock-register.component.scss'],
  providers: [TimeClockRegisterViewService],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimeClockRegisterComponent implements OnInit, OnDestroy {

  constructor(private readonly viewService: TimeClockRegisterViewService) { }

  ngOnInit() {
    this.viewService.initialize();
  }

  ngOnDestroy(): void {
    this.viewService.finalize();
  }

  get model(): ContainerModel {
    return this.viewService.componentModel;
  }

}
